<template>
  <div class="scroll">
    <div class="container content-scroll">
      <div v-if="results.length < 1">
        No Results Found. Please refine your search and try again.
      </div>
      <div v-for="(result, index) in results" :key="index">

        <div class="result" v-if="result._type === 'owner'">
          <router-link tag="a" :to="{ name:'ownerEdit', params:{'customer':result}, query:{'id': result._source.uuid}}"><h5>{{ result._source.name }}</h5></router-link>
          <small>{{ result._type | capitalize}} | Effective - {{result._source.effective_date}}</small>
          <div class="dataGroup" v-if="result.highlight" :key="index">
            <p class="otherData">Owner Name - {{result._source.contacts[0].name}}, Owner Email - {{result._source.contacts[0].email}}, Owner Phone - {{result._source.contacts[0].phone}}</p>
            <p class="hit"><span v-for="(searchHit, index) in result.highlight" :key="index">{{index | splitString}} - <span class="highlight" v-html="searchHit[0]"></span>, </span></p>
          </div>
        </div>

        <div class="result" v-if="result._type === 'store'">
          <router-link tag="a" :to="{ name:'storeEdit', params:{'customer':result}, query:{'id': result._source.uuid}}"><h5>{{ result._source.name }}</h5></router-link>
          <small>{{ result._type | capitalize}} | Effective - {{result._source.effective_start_date}}</small>
          <div class="dataGroup" v-if="result.highlight" :key="index">
            <p class="otherData">Cust Id - {{result._source.billing.customer_id}}, Wholesaler - {{result._source._groups.description}}, Owner - {{result._source.owner_group}}</p>
            <p class="hit"><span v-for="(searchHit, index) in result.highlight" :key="index">{{index | splitString}} - <span class="highlight" v-html="searchHit[0]"></span>, </span></p>
          </div>
        </div>

        <div class="result" v-if="result._type === 'vendor'">
          <router-link tag="a" :to="{ name:'vendorEdit', params:{'customer':result}, query:{'id': result._source.uuid}}"><h5>{{ result._source.name }}</h5></router-link>
          <small>{{ result._type | capitalize}}</small>
          <div class="dataGroup" v-if="result.highlight" :key="index">
            <p class="otherData">Wholesaler - {{result._source._groups.description}}</p>
            <p class="hit"><span v-for="(searchHit, index) in result.highlight" :key="index">{{index | splitString}} - <span class="highlight" v-html="searchHit[0]"></span>, </span></p>
          </div>
        </div>

        <div class="result" v-if="result._type === 'group'">
          <router-link tag="a" :to="{ name:'groupEdit', params:{'customer':result}, query:{'id': result._source.uuid}}"><h5>{{ result._source.name }}</h5></router-link>
          <small>{{ result._type | capitalize}}</small>
          <div class="dataGroup" v-if="result.highlight" :key="index">
            <p class="otherData">Wholesaler - {{result._source.description}}</p>
            <p class="hit"><span v-for="(searchHit, index) in result.highlight" :key="index">{{index | splitString}} - <span class="highlight" v-html="searchHit[0]"></span>, </span></p>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'
import { store } from '../store/index'
import { API } from 'aws-amplify'

export default {
  name: 'search',
  data () {
    return {
      results: []
    }
  },
  props: [
  ],
  components: {
  },
  created () {
  },
  mounted () {
    this.search(this.$route.query.q)
  },
  watch: {
    $route (to, from) {
      this.search(to.query.q)
    }
  },
  computed: {
  },
  filters: {
    splitString: function (value) {
      if (!value) return ''
      value = value.replace('.', ' ')

      value = value.toLowerCase().split(' ')
      for (var i = 0; i < value.length; i++) {
        value[i] = value[i].charAt(0).toUpperCase() + value[i].slice(1)
      }
      return value.join(' ')
    }
  },
  methods: {
    search () {
      this.results = []
      let self = this
      if (this.$route.query.search_by === 'All') {
        API.post('all', '/_search', {
          'body': {
            'size': 0,
            'query': {
              'multi_match': {
                'query': this.$route.query.q,
                'type': 'phrase_prefix',
                'fields': []
              }
            },
            'aggs': {
              'dedup': {
                'terms': {
                  'size': 25,
                  'field': 'uuid.keyword',
                  'order': {
                    'max_score': 'desc'
                  }
                },
                'aggs': {
                  'dedup_docs': {
                    'top_hits': {
                      'size': 1,
                      'track_scores': true,
                      'sort': [
                        {
                          'revision': {
                            'order': 'desc'
                          }
                        }
                      ],
                      'highlight': {
                        'order': 'score',
                        'pre_tags': ['<em>'],
                        'post_tags': ['</em>'],
                        'fields': {
                          '*': {}
                        }
                      }
                    }
                  },
                  'max_score': {
                    'max': {
                      'script': '_score'
                    }
                  }
                }
              }
            }
          }
        }).then(function (response) {
          console.log('response: ', response)
          response.aggregations.dedup.buckets.forEach(function (result) {
            if (result.dedup_docs.hits.hits[0]._type === 'store') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.groups.includes(group.uuid) && group.group_type === 'WHOLESALER') {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group
                  axios.post('https://search-customers-cv7agc2jvwfaum56cpllo3jqam.us-east-1.es.amazonaws.com/_search', {
                    'size': 1,
                    'query': {
                      'match': {
                        'uuid': result.dedup_docs.hits.hits[0]._source.billing.owner
                      }
                    }
                  }).then(response => {
                    result.dedup_docs.hits.hits[0]['_source']['owner_group'] = response.hits.hits[0]._source.name
                    self.results.push(result.dedup_docs.hits.hits[0])
                  })
                }
              })
            } else if (result.dedup_docs.hits.hits[0]._type === 'vendor') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.wholesaler_group === group.uuid) {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group
                  self.results.push(result.dedup_docs.hits.hits[0])
                }
              })
            } else {
              self.results.push(result.dedup_docs.hits.hits[0])
            }
          })
        })
      } else if (this.$route.query.search_by === 'uuid') {
        axios.post('https://search-customers-cv7agc2jvwfaum56cpllo3jqam.us-east-1.es.amazonaws.com/_search', {
          'size': 0,
          'query': {
            'bool': {
              'must': {
                'match_phrase': {
                  'uuid': this.$route.query.q
                }
              }
            }
          },
          'aggs': {
            'dedup': {
              'terms': {
                'size': 25,
                'field': 'uuid.keyword',
                'order': {
                  'max_score': 'desc'
                }
              },
              'aggs': {
                'dedup_docs': {
                  'top_hits': {
                    'size': 1,
                    'track_scores': true,
                    'sort': [
                      {
                        'revision': {
                          'order': 'desc'
                        }
                      }
                    ],
                    'highlight': {
                      'order': 'score',
                      'pre_tags': ['<em>'],
                      'post_tags': ['</em>'],
                      'fields': {
                        '*': {}
                      }
                    }
                  }
                },
                'max_score': {
                  'max': {
                    'script': '_score'
                  }
                }
              }
            }
          }
        }).then(function (response) {
          response.data.aggregations.dedup.buckets.forEach(function (result) {
            if (result.dedup_docs.hits.hits[0]._type === 'store') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.groups.includes(group.uuid) && group.group_type === 'WHOLESALER') {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group._source
                  axios.post('https://search-customers-cv7agc2jvwfaum56cpllo3jqam.us-east-1.es.amazonaws.com/_search', {
                    'size': 1,
                    'query': {
                      'match': {
                        'uuid': result.dedup_docs.hits.hits[0]._source.billing.owner
                      }
                    }
                  }).then(response => {
                    result.dedup_docs.hits.hits[0]['_source']['owner_group'] = response.data.hits.hits[0]._source.name
                    self.results.push(result.dedup_docs.hits.hits[0])
                  })
                }
              })
            } else if (result.dedup_docs.hits.hits[0]._type === 'vendor') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.wholesaler_group === group.uuid) {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group._source
                  self.results.push(result.dedup_docs.hits.hits[0])
                }
              })
            } else {
              self.results.push(result.dedup_docs.hits.hits[0])
            }
          })
        })
      } else {
        let index = this.$route.query.search_by.toLowerCase()
        axios.post('https://search-customers-cv7agc2jvwfaum56cpllo3jqam.us-east-1.es.amazonaws.com/' + index + '/_search', {
          'size': 0,
          'query': {
            'bool': {
              'must': {
                'multi_match': {
                  'query': this.$route.query.q,
                  'type': 'best_fields',
                  'fields': [
                  ],
                  'fuzziness': 'AUTO'
                }
              }
            }
          },
          'aggs': {
            'dedup': {
              'terms': {
                'size': 25,
                'field': 'uuid.keyword',
                'order': {
                  'max_score': 'desc'
                }
              },
              'aggs': {
                'dedup_docs': {
                  'top_hits': {
                    'size': 1,
                    'track_scores': true,
                    'sort': [
                      {
                        'revision': {
                          'order': 'desc'
                        }
                      }
                    ],
                    'highlight': {
                      'order': 'score',
                      'pre_tags': ['<em>'],
                      'post_tags': ['</em>'],
                      'fields': {
                        '*': {}
                      }
                    }
                  }
                },
                'max_score': {
                  'max': {
                    'script': '_score'
                  }
                }
              }
            }
          }
        }).then(function (response) {
          response.data.aggregations.dedup.buckets.forEach(function (result) {
            if (result.dedup_docs.hits.hits[0]._type === 'store') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.groups.includes(group._source.uuid) && group._source.group_type === 'WHOLESALER') {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group._source
                  axios.post('https://search-customers-cv7agc2jvwfaum56cpllo3jqam.us-east-1.es.amazonaws.com/_search', {
                    'size': 1,
                    'query': {
                      'match': {
                        'uuid': result.dedup_docs.hits.hits[0]._source.billing.owner
                      }
                    }
                  }).then(response => {
                    result.dedup_docs.hits.hits[0]['_source']['owner_group'] = response.data.hits.hits[0]._source.name
                    self.results.push(result.dedup_docs.hits.hits[0])
                  })
                }
              })
            } else if (result.dedup_docs.hits.hits[0]._type === 'vendor') {
              store.state.groups.forEach(function (group) {
                if (result.dedup_docs.hits.hits[0]._source.wholesaler_group === group._source.uuid) {
                  result.dedup_docs.hits.hits[0]['_source']['_groups'] = group._source
                  self.results.push(result.dedup_docs.hits.hits[0])
                }
              })
            } else {
              self.results.push(result.dedup_docs.hits.hits[0])
            }
          })
        })
      }
    }
  }
}
</script>
<style lang="less" scoped>
  @import '../less/elements/color.less';
  .result{
    padding: 15px 0;
    color: @color-text;
    p{
      line-height: 1;
    }
  }
  a{
    text-decoration: none;
    color: @color-text;
    h5{
      line-height: 1;
      margin-bottom: -3px;
      display: block;
      font-family: 'Raleway', sans-serif;
      letter-spacing: 0.03rem;
    }
    &:hover{
      font-style: italic;
      color: lighten(@color-text, 10%);
    }
  }
  small {
    -webkit-transition-property: color;
    transition-property: color;
    text-decoration: none;
    font-family: 'Raleway', sans-serif;
    letter-spacing: 0.03rem;
    font-style: italic;
    font-size: .8rem;
    margin-bottom: .5rem
  }
  .dataGroup{
    margin-top: .5rem;
  }
  p{
    font-size: .85rem;
    margin-bottom: .4em;
    font-family: 'Raleway', sans-serif;
    letter-spacing: 0.03rem;
    .highlight{
      font-weight: 600;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/search.vue